




















































import { VueConstructor } from 'vue';
import _ from 'lodash';
import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';

@Component
export default class RepeatableInputGroup extends Vue {
  @Prop({ default: 'div' })
  tag!: string | VueConstructor;

  @Prop({ default: () => [] })
  propagatedValue!: Record<any, any>[];

  @Prop({ default: true, type: Boolean })
  hasRemoveButton!: boolean;

  @Prop({ default: true, type: Boolean })
  hasAddMoreButton!: boolean;

  @Prop({ default: () => null })
  validations!: any;

  @Prop({ default: () => null })
  model!: any;

  getValidations(index: number) {
    return this?.validations?.$each?.[index] || {};
  }

  addMore() {
    if (!this.propagatedValue) {
      this.$emit('input', [this.model]);
      return;
    }
    this.propagatedValue.splice(this.propagatedValue.length, 0, _.cloneDeep(this.model));
    this.onInput();
  }

  removeItem(index: number) {
    this.propagatedValue.splice(index, 1);
    this.onInput();
  }

  onInput() {
    this.$emit('input', this.propagatedValue);
  }
}
